import { Badge } from '@mantine/core';
import { t } from '../lib/strings';

// Colours the four invoice/settlement values: active (billed/paid) = green/blue,
// inactive (not billed/paid) = gray. Used for both Myyntilaskutustila + Tilitystila.
const COLORS: Record<string, string> = {
  Laskutettu: 'green',
  'Hyväksytty laskutukseen': 'blue',
  'Ei voida hyväksyä laskutukseen': 'gray',
  'Ei laskuteta': 'gray',
};

export function InvoiceBadge({ status }: { status?: string | null }) {
  if (!status) return <>—</>;
  return (
    <Badge color={COLORS[status] ?? 'gray'} variant="light" size="xs" radius="sm">
      {t.invoice.values[status] ?? status}
    </Badge>
  );
}
